export default {
  siteKey: process.env.VUE_APP_RECAPCHA_SITE_KEY,
}
